import { render, staticRenderFns } from "./bindingPhone.vue?vue&type=template&id=736314f6&scoped=true&"
import script from "./bindingPhone.vue?vue&type=script&lang=js&"
export * from "./bindingPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindingPhone.vue?vue&type=style&index=0&id=736314f6&lang=less&scoped=true&"
import style1 from "./bindingPhone.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736314f6",
  null
  
)

export default component.exports